import { render } from "./customAccordion.vue?vue&type=template&id=328fd1db"
import script from "./customAccordion.vue?vue&type=script&lang=js"
export * from "./customAccordion.vue?vue&type=script&lang=js"

import "./customAccordion.vue?vue&type=style&index=0&id=328fd1db&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__